// @ts-nocheck

import { request } from '../../../../../../../context';
import type { ApiOptions } from '../../../../../../../context';
import type {
    PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdParam,
    PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdBody,
    BaseResponseIntelligentPartnerDialogNodeAiTemplateFoundResponse,
} from '../../../../../../../types';

/**
 * updateSceneById
 *
 * @export
 * @tags 智能陪练-AI输入场景节点配置
 * @link [PUT] /review/intelligentPartner/node/inputSceneConfig/manage/updateSceneById/{id}
 * @param id
 */
export function putReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdById(
    data: PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdBody,
    options: ApiOptions<
        PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdParam,
        never
    > & { segments: PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdParam }
): Promise<BaseResponseIntelligentPartnerDialogNodeAiTemplateFoundResponse> {
    return request<
        PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdBody,
        PutReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdByIdParam,
        never
    >('/review/intelligentPartner/node/inputSceneConfig/manage/updateSceneById/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName:
            'putReviewIntelligentPartnerNodeInputSceneConfigManageUpdateSceneByIdById',
    });
}

export const meta = [
    {
        tags: ['智能陪练-AI输入场景节点配置'],
        path: '/review/intelligentPartner/node/inputSceneConfig/manage/updateSceneById/{id}',
        method: 'put',
    },
];
